import React, { useEffect, useRef } from "react";
import L from "leaflet";
import 'leaflet/dist/leaflet.css';
import { createControl, initImmobilierLegend, initMinimalLegend, mountImmoFeatures, positionMarker } from "../../utils/map/mapUtils";
import { onlyUniqueByKey } from "../../utils/overlaysUtils";
import { createGrayScaleLayer } from "../../utils/map/basemaps";
require("../../utils/leaflet/Leaflet.VectorGrid.bundled")

export const QuizMap = ({coordinates, itemData}) => {
    const mapRef = useRef(undefined);
    const overlaysGroupRef = useRef(undefined);
    const legendRef = useRef(undefined);
    const outlineCityRef = useRef(undefined);

    useEffect(() => {
        mapRef.current = L.map('quiz-map', {
            zoomControl: false,
            zoomSnap: 0.25,
            minZoom: 7
        });
        legendRef.current = createControl('topleft', false, false);
        overlaysGroupRef.current = L.layerGroup().addTo(mapRef.current);

        //grayScaleLayer
        createGrayScaleLayer().addTo(mapRef.current);

        //zoom
        L.control.zoom({position: "bottomright"}).addTo(mapRef.current);
        positionMarker(coordinates.address, mapRef.current);

        if(!itemData.layer.startsWith('immobilier')){
            fetch(`/values/${itemData.layer}`)
                .then(res => res.json())
                .then(values => {
                    initMinimalLegend(legendRef.current, values.filter(onlyUniqueByKey("label")), mapRef.current);
                    return values;
                })
                .then(values => {
                    overlaysGroupRef.current.addLayer(L.vectorGrid.protobuf(`/tiles/${itemData.layer}/{z}/{x}/{y}.pbf`, {
                        interactive: false,
                        vectorTileLayerStyles: {[itemData.layer]: (properties) => ({
                            weight: 1,
                            color: properties.color,
                            fillColor: properties.color,
                            fillOpacity: 0.7,
                            fill: true,
                        })},
                        zIndex: 10
                    }))
                })
        } else {
            mapRef.current.fitBounds(coordinates.address 
                ? L.latLngBounds([coordinates.address.lat + 0.03, coordinates.address.lon + 0.03], [coordinates.address.lat - 0.03, coordinates.address.lon - 0.03])
                : outlineCityRef.current.getBounds()
            );
            const geoJsonData = JSON.parse(itemData.geoJsonData);
            if(geoJsonData.estimates.length > 0){
                const features = mountImmoFeatures(geoJsonData, itemData.layer.split('-')[1], coordinates.codeInsee);
                overlaysGroupRef.current.addLayer(features);

                initImmobilierLegend(legendRef.current, geoJsonData.estimates, itemData.layer.split('-')[1], coordinates.codeInsee, mapRef.current);
            }
        }
    }, [])

    return (
        <div className="information-content__map pl-lg-5 flex-grow-1 w-100">
            <p className="font-weight-bold">{itemData.title}</p>
            <div id="quiz-map" style={{ height: '300px'}} role="img"></div>
        </div>
    )
}